export default __webpack_public_path__ + "img/angry-vote.fee3e6f.svg";